
// @ts-nocheck
import axios from "axios";
import * as FormData from "form-data";
const form = new FormData();

export function requestPageData(pageInfo: pageData): Promise<any> {
    appendData(pageInfo)
    return new Promise<any>((resolve, reject) => {
        axios.post('/mx-aguas-firmes-core/get', form)
            .then((response: any) => {
                resolve(response.data)
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

function appendData({ content, nid, langcode }: pageData): void {
    form.append('content', content);
    form.append('nid', parseInt(nid));
    form.append('langcode', langcode);
}